import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function blockPackagesSliderScript() {
    document.addEventListener('DOMContentLoaded', function () {
        const blocksSmall = document.querySelectorAll('.packages__sliders');
        const content_tags = document.querySelectorAll('.content_tags');

        blocksSmall.forEach(block => {
            let smallIcon = new Splide(block, {
                type: 'loop',
                perPage: 3.1,
                pagination: false,
                perMove: 1,
                arrows: true,
                drag: false,
                swipe: false,
                breakpoints: {
                    1400: { perPage: 3.1, arrows: true, gap: 18, drag: true, swipe: true },
                    992: { perPage: 2.1, arrows: true, gap: 18, drag: true, swipe: true },
                    599: { perPage: 1.1, arrows: true, gap: 18, drag: true, swipe: true },
                },
            });
            smallIcon.mount();
        });

        let maxHeight = 0;
        content_tags.forEach(single=>{
            maxHeight = maxHeight > single.offsetHeight ? maxHeight : single.offsetHeight
        })

        content_tags.forEach(single=>{
            single.style.height = maxHeight + 'px'
        })

        let content_plus = document.querySelectorAll('.content_plus');
        content_plus.forEach(single=>{
            single.addEventListener('click', function(){
                if (single.parentNode.classList.contains('active__list')){
                    removeActiveClass();
                }else{
                    addActiveClass();
                }
            })
        })

        function removeActiveClass() {
            content_plus.forEach(link => {
                link.classList.remove('active__list');
                link.querySelector('img').attributes.src.value = link.querySelector('img').getAttribute('data-plus');
                link.parentNode.classList.remove('active__list')
            });
        }

        function addActiveClass() {
            content_plus.forEach(link => {
                link.classList.add('active__list');
                link.querySelector('img').attributes.src.value = link.querySelector('img').getAttribute('data-minus');
                link.parentNode.classList.add('active__list')
            });
        }
    })
}